<template>
  <div class="bg-white shrink-0 flex flex-row items-center overflow-x-auto overflow-y-hidden border-b border-gray-200 md:w-20 md:flex-col md:overflow-y-auto md:overflow-x-hidden md:border-b-0 md:border-r">
    <!-- Navigation Items -->
    <nav class="flex flex-row w-full md:flex-1 md:flex-col md:w-full">
      <div class="flex flex-row md:flex-col"><!-- Main Pages -->
        <!-- <MainNavItem
          label="Home"
          to="/home"
          :icon="['fal', 'grid-2']"
        /> -->
        <MainNavItem
          label="Insights"
          to="/insight"
          :icon="['fas', 'chart-bar']"
        />
        <MainNavItem
          v-if="current_user?.is_superuser"
          label="Impact"
          to="/impact"
          :icon="['fas', 'flask-vial']"
        />
        <MainNavItem
          label="Pages"
          to="/pages"
          :icon="['fas', 'file-lines']"
        />
        <MainNavItem
          v-if="canAccessFeature(FEATURES.MODULE_AGENT)"
          label="Hermes"
          to="/agent"
          :icon="['fas', 'foot-wing']"
        />
        <MainNavItem
          v-if="canAccessFeature(FEATURES.MODULE_ENGAGE)"
          label="Engage"
          to="/engage"
          :icon="['fas', 'badge-check']"
        />
        <MainNavItem
          label="Patient"
          to="/patients"
          :icon="['fas', 'user']"
        />
        <MainNavItem
          label="Portal"
          to="/portal"
          :icon="['fas', 'hospital']"
        />
        <MainNavItem
          v-if="canAccessFeature(FEATURES.MODULE_EXTERNAL)"
          label="External"
          :to="current_entity_id ? `/external/${current_entity_id}` : '/external'"
          :icon="['fas', 'share-nodes']"
        />
        <MainNavItem
          label="Coding"
          to="/coding"
          :icon="['fas', 'file-invoice']"
        />
        <MainNavItem
          label="Quality"
          to="/quality"
          :icon="['fas', 'tasks']"
        />
        <MainNavItem
          v-if="canAccessFeature(FEATURES.MODULE_CARE_MANAGEMENT)"
          label="Care Mgmt"
          to="/caremanagement"
          :icon="['fas', 'user-nurse']"
        />
        <MainNavItem
          label="Growth"
          to="/growth"
          :icon="['fas', 'seedling']"
        />
        <MainNavItem
          v-if="canAccessFeature(FEATURES.MODULE_SERVICE_DESK) || current_user?.is_staff"
          label="Support"
          to="/support"
          :icon="['fas', 'headset']"
        />
        <MainNavItem
          v-if="current_user?.is_superuser || current_tenant_slug === 'wellvana'"
          label="Beta"
          to="/beta"
          :icon="['fas', 'flask']"
        />
      </div>
      <div class="flex flex-row md:flex-col md:mt-auto"><!-- Admin Pages -->
        <MainNavItem
          v-if="canAccessFeature(FEATURES.MODULE_ADMIN)"
          label="Admin"
          to="/tenantadmin"
          :icon="['fas', 'users-cog']"
        />
        <MainNavItem
          v-if="canAccessFeature(FEATURES.MODULE_DATA)"
          label="Data"
          to="/data"
          :icon="['fas', 'table']"
        />
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MainNavItem from './MainNavItem.vue';
import { canAccessFeature } from '@/utils/access';
import { FEATURES } from '@/constants/features';

export default {
  name: 'MainNavSidebar',
  components: {
    MainNavItem
  },
  methods: {
    canAccessFeature,
  },
  computed: {
    ...mapGetters('auth', ['current_user']),
    ...mapGetters('tenant', ['current_tenant_slug']),
    FEATURES: () => FEATURES,
  }
};
</script>

<style scoped>
/* Make icon orange when nav item is active */
:deep(.router-link-active svg) {
  color: #F76734;
}
</style>
